import { GlFilteredSearchSuggestion, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { s__ } from '~/locale';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import getCiCatalogResourceVersions from '~/ci/catalog/graphql/queries/get_ci_catalog_resource_versions.query.graphql';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'VersionToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion,
        GlIcon
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            versions: [],
            allVersions: [],
            searchTerm: null
        };
    },
    apollo: {
        versions: {
            query: getCiCatalogResourceVersions,
            variables () {
                return {
                    fullPath: this.config.resourcePath,
                    search: this.searchTerm
                };
            },
            skip () {
                return this.searchTerm === null;
            },
            update (data) {
                return (data?.ciCatalogResource?.versions?.nodes || []).map((v)=>({
                        value: v.id,
                        text: v.name
                    }));
            },
            result ({ data }) {
                if (!data?.ciCatalogResource?.versions?.nodes) return;
                this.updateAllVersions(this.versions);
            },
            error () {
                createAlert({
                    message: s__('CiCatalog|There was an error fetching versions.')
                });
            }
        }
    },
    computed: {
        loading () {
            return this.$apollo.queries.versions.loading;
        },
        versionNameMap () {
            return Object.fromEntries(this.allVersions.map((v)=>[
                    v.value,
                    v.text
                ]));
        }
    },
    methods: {
        updateAllVersions (versions) {
            versions.forEach((version)=>{
                if (!this.allVersions.some((v)=>v.value === version.value)) {
                    this.allVersions.push(version);
                }
            });
        },
        getActiveTokenValue (suggestions, data) {
            return suggestions.find((s)=>s.value === data) || this.allVersions.find((v)=>v.value === data);
        },
        selectedTokensText (selectedIds) {
            return selectedIds.map((id)=>this.versionNameMap[id] || id).join(', ');
        }
    }
};
